<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Produk Detail</h1>
            <div class="section-header-breadcumb button">
                <button class="btn btn-outline-warning" style="margin-right:5px" @click="showingStokOpname(id_produk)"> <i class="fa fa-sort"></i> Stok Opname</button>
                <button class="btn btn-danger" style="margin-right:5px" @click="deleteProduk(id_produk)"> <i class="fa fa-trash"></i> Delete Produk</button>
                <a href="javascript:" @click.prevent="goTo('/produk/daftar-produk/edit-produk/'+id_produk)" class="btn btn-icon icon-left btn-primary"><i class="far fa-edit"></i> Ubah Produk</a>
            </div>
          </div>
        <div class="section-body">
            <h2 class="section-title">Nama Produk : {{ produkDetail.detail.nama_produk }}</h2>
            <p class="section-lead">Kode Produk : {{ produkDetail.detail.kode_produk }}</p>

            <div class="row">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Utama</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-hover">
                                <tbody>
                                    <tr>
                                        <th style="width:50%;">
                                            Kode Produk  
                                        </th>
                                        <td>
                                            {{ produkDetail.detail.kode_produk }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Stok Sekarang  
                                        </th>
                                        <td>
                                            {{ produkDetail.detail.qty_total }} {{ produkDetail.detail.nama_satuan }} <span v-if="produkDetail.dipesan > 0">(dipesan {{ produkDetail.dipesan }})</span> 
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Akun Penyimpanan  
                                        </th>
                                        <td>
                                            ({{ produkDetail.akun_persediaan.kode_akun }}) {{ produkDetail.akun_persediaan.nama_akun }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Harga Rata-Rata  
                                        </th>
                                        <td>
                                            Rp. {{ currencyFormat(produkDetail.detail.harga_jual) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Kategori Produk  
                                        </th>
                                        <td>
                                            <span v-for="kategori in produkDetail.kategori" :key="kategori.id_produk_kategori"> {{ kategori.nama_kategori_produk }} ,</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Deskripsi  
                                        </th>
                                        <td>
                                            {{ produkDetail.detail.deskripsi_produk }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Alias</h4>
                        </div>
                        <div style="height:376px;overflow-y:auto" class="card-body">
                            <table class="table table-striped">
                                <tr>
                                    <th>
                                        Kode Alias
                                    </th>
                                    <th>
                                        Nama Alias
                                    </th>
                                    <th>
                                        Deskripsi Alias
                                    </th>
                                </tr>
                                <tbody>
                                    <tr v-for="alias in produkDetail.alias" :key="alias.id_alias">
                                        <td> {{ alias.kode_alias }} </td>
                                        <td> {{ alias.nama_alias }} </td>
                                        <td> {{ alias.deskripsi_alias }} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">

                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-md-6 col-lg-6">
                    <div v-if="produkDetail.detail.is_produksi == 0" class="card">
                        <div class="card-header">
                            <h4>Informasi Pembelian</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-hover">
                                <tbody>
                                    <tr>
                                        <th>
                                            Harga Beli Satuan
                                        </th>
                                        <td>
                                            {{ currencyFormat(produkDetail.detail.harga_beli) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Akun Pembelian
                                        </th>
                                        <td>
                                            ({{ produkDetail.akun_beli.kode_akun }}) {{ produkDetail.akun_beli.nama_akun }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else class="card">
                        <div class="card-header">
                            <h4>Informasi Produksi</h4>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <tr>
                                        <th>Produk</th>
                                        <th>Kuantitas</th>
                                        <th>Perkiraan Biaya Satuan</th>
                                        <th>Sisa Stok</th>
                                        <th>Kapabilitas Produksi </th>
                                    </tr>
                                    <tbody>
                                        <tr v-for="option in dataProduksi" v-bind:key="option.id_produk">
                                            <td style="cursor:pointer" @click="goDetailProduk(option.id_produk)" >
                                                {{ option.nama_produk }}
                                            </td>
                                            <td>
                                                {{ option.qty }} {{ option.nama_satuan }}
                                            </td>
                                            <td>Rp. {{ currencyFormat(option.perkiraan_biaya) }}</td>
                                            <td>
                                                {{ option.qty_total }} {{ option.nama_satuan }}
                                            </td>
                                            <td>
                                                {{ option.kapabilitas }} {{ option.nama_satuan }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table table-hover">
                                    <tr>
                                        <th style="width:33%;">Kapabilitas Produksi : {{ kapabilitasProduksiComputed }} {{ produkDetail.detail.nama_satuan }}</th>
                                        
                                        <th style="text-align:right;width:30%;">
                                            <button v-if="is_produce == false" class="btn btn-primary" @click="setsProduce()"> <i class="fas fa-flask"></i> Produce</button>
                                        </th>
                                    </tr>
                                    <tr v-if="is_produce == true">
                                        <th> <input class="form-control" type="number" v-model="qty_produce" placeholder="Masukkan Qty Produksi" :max="kapabilitasProduksiComputed" min="0"> </th>
                                        <th>
                                            Total Biaya : Rp.{{ currencyFormat(computePerkiraanProduksi) }}
                                        </th>
                                        <th>
                                            <button class="btn btn-primary" @click="submitProduce()"> <i class="fas fa-flask"></i> Submit Produce</button> 
                                        </th>
                                    </tr>
                                    <tbody v-if="is_produce == true">
                                        <tr v-for="option in dataProduksi" v-bind:key="option.id_produk">
                                            <td>
                                                {{ option.nama_produk }}
                                            </td>
                                            <td>
                                                Dipakai
                                            </td>
                                            <td> {{ Number(option.qty * qty_produce).toFixed(2) }} {{ option.nama_satuan }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Penjualan</h4>
                        </div>
                        <div class="card-body">
                            <table class="table table-hover">
                                <tbody>
                                    <tr>
                                        <th>
                                            Harga Jual Satuan
                                        </th>
                                        <td>
                                            {{ currencyFormat(produkDetail.detail.harga_jual) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Akun Penjualan
                                        </th>
                                        <td>
                                            ({{ produkDetail.akun_jual.kode_akun }}) {{ produkDetail.akun_jual.nama_akun }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>History Produk</h4>
                            <div class="card-header-form">
                                <div class="input-group">
                                    <label class="mr-1 font-weight-bold">Tanggal Mulai</label>
                                    <vc-date-picker v-model="tanggal_mulai" :input-props='{class: "form-control",placeholder: "Tanggal Mulai",style:"display:inline;"}'/>
                                    <div class="input-group-btn mr-3">
                                        <button class="btn btn-primary"><i class="fa fa-calendar"></i></button>
                                    </div>
                                    <label class="mr-1 font-weight-bold">Tanggal Selesai</label>
                                    <vc-date-picker v-model="tanggal_selesai" :input-props='{class: "form-control",placeholder: "Tanggal Selesai",style:"display:inline;"}'/>
                                    <div class="input-group-btn mr-4">
                                        <button class="btn btn-primary"><i class="fa fa-calendar"></i></button>
                                    </div>
                                    <a :href="siteUrl+'Produk/exportHistory/'+id_produk+'?tanggal_mulai='+formatDate(tanggal_mulai)+'&tanggal_selesai='+formatDate(tanggal_selesai)" target="_blank" style="padding:7px 0px 0px 0px" class="btn btn-outline-info"><i class="fa fa-file-excel-o"></i> Export to Excel</a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-striped table-hover">
                                    <tr>
                                        <th width="10px">#</th>
                                        <th>Deskripsi</th>
                                        <th>Tanggal</th>
                                        <th>Tipe</th>
                                    </tr>
                                    <tbody>
                                        <tr style="cursor:pointer;" v-for="(item,index) in produkDetail.history" :key="item.id_history" @click="goDetailHistory(index)">
                                            <td> {{ index+1 }} </td>
                                            <td>
                                                {{ item.description_item }}
                                            </td>
                                            <td>
                                                {{ item.created_at | moment("DD MMMM YYYY") }}
                                            </td>
                                            <td style="text-transform:capitalize;">
                                                {{ item.value_item }}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td style="text-align:center;cursor:pointer;" colspan="4"><a href="javascript:" @click="viewMoreHistory()"> View More History </a>  </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button @click="goBack()" class="btn btn-danger">Kembali</button>
                </div>
            </div>
        </div>
        </section>
        <div class="modal show"  v-if="showStokOpname">
            <div class="modal-content">
                <stok-opname :id_produk="this.id_produk"></stok-opname>
            </div>
        </div>
    </div>
</template>
<style>
td {
    height: 30px;
}

.modal {
  padding-top: 5%; /* Location of the box */
  padding-bottom: 5%;
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 70%;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s
}

.show {
    display : block !important;
}

@-webkit-keyframes animatetop {
  from {top:-300px; opacity:0} 
  to {top:0; opacity:1}
}

@keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}
</style>

<script>
import Vue from 'vue'
import StokOpname from './StokOpname.vue'


export default {
    data() {
        return {
            produkDetail : {
                detail : {
                    nama_produk : '',
                    // kode_produk : '',
                    // qty_total : '',
                    // nama_satuan : '',
                    // harga_jual : 1000,
                    // deskripsi : '',
                },
                akun_persediaan : {
                    kode_akun : '',
                    nama_akun : '',
                },
                akun_beli : {
                    kode_akun : '',
                    nama_akun : '',
                },
                akun_jual : {
                    kode_akun : '',
                    nama_akun : '',
                }
            },
            id_produk : '',
            dataProduksi : [],
            kapabilitasProduksi : [],
            qty_produce : 0,
            is_produce : false,
            showStokOpname : false,
            rowHistory : 10,
            tanggal_mulai : new Date,
            tanggal_selesai : new Date,
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
            url : ''
        }
    },
    mounted() {
        this.url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        this.url = this.url.split('-');    
        this.id_produk = this.$route.params.id_produk;
        this.init();
    },
    methods: {
        init: function() {
            // get Produk Detail
            this.$root.is_loading = !this.$root.is_loading;
			this.$http.post("Produk/getProdukDetail/"+this.id_produk).then(result => {
			    if(result.data.code == '00') {
                    alert('failed get Detail')
                }
                else {
                    this.produkDetail = result.data.detail
                    if(this.produkDetail.detail.is_produksi == "1"){
                        this.$http.post("Produk/getBahan/"+this.id_produk).then(result => {
                            if(result.data.code == '00') {
                                alert('failed get bahan list')
                            }
                            else {
                                this.dataProduksi = result.data.detail
                                let that = this
                                this.dataProduksi.forEach(function(val,index){
                                    that.dataProduksi[index].kapabilitas = Number(val.qty_total / val.qty).toFixed(2);
                                    that.kapabilitasProduksi.push(that.dataProduksi[index].kapabilitas);
                                })
                            }
                        }, error => {
                            console.log('gk ok')
                            context.errors = errors;
                        });
                    }
                }
                this.$root.is_loading = !this.$root.is_loading;
			}, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            });
            
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        MoneyCallback(x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        goTo: function(paths) {
            this.$router.replace({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        setsProduce(){
            this.is_produce = true;
        },
        submitProduce() {
            if(this.qty_produce > this.kapabilitasProduksiComputed){
                this.$parent.toastr = {
                    title : 'Error',
                    message: 'Qty produce melebihi batas !',
                    type : 'error'
                }
                return false;
            }
            
            var formsub = new FormData()
            formsub.append('qty_produce',this.qty_produce);
            formsub.append('total_biaya',this.computePerkiraanProduksi);
            formsub.append('id_produk', this.id_produk);

            this.$http.post("Produk/prosesProduksi/"+this.id_produk, formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Produk berhasil di produksi !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.qty_produce = 0
                        this.init();
                    });
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Failed Produksi !',
                        type : 'error'
                    }              
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
            });
            
        },
        goBack: function() {
            this.$router.go(-1)
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        goDetailProduk: function(id_produk) {
            this.$router.push({ path: '/produk/produk-detail/'+id_produk });
        },
        goDetailHistory: function(index) {
            if(this.produkDetail.history[index].table_history == 'transaksi') {
                if(this.produkDetail.history[index].value_item == 'pembelian') {
                    this.$router.replace({ path : '/pembelian/list/pemesanan-pembelian-detail/'+this.produkDetail.history[index].id_table+'/pemesanan' })
                }else if(this.produkDetail.history[index].value_item == 'penjualan') {
                    this.$router.replace({ path : '/penjualan/list/pemesanan-penjualan-detail/'+this.produkDetail.history[index].id_table+'/pemesanan' })
                }
                this.$nextTick(function(){
                    this.$parent.setLastRoute();
                })
            }else if(this.produkDetail.history[index].table_history == 'produksi') {
                this.$router.replace({ path : '/produk/produksi-detail/'+this.produkDetail.history[index].id_table })
                this.$nextTick(function(){
                    this.$parent.setLastRoute();
                })
            }else if(this.produkDetail.history[index].table_history == 'transaksi_progress') {
                if(this.produkDetail.history[index].value_item == 'pembelian') {
                    this.$router.replace({ path : '/pembelian/list/pengiriman-pembelian-detail/'+this.produkDetail.history[index].id_table+'/pengiriman' })
                }else if(this.produkDetail.history[index].value_item == 'penjualan') {
                    this.$router.replace({ path : '/penjualan/list/pengiriman-penjualan-detail/'+this.produkDetail.history[index].id_table+'/pengiriman' })
                }
                this.$nextTick(function(){
                    this.$parent.setLastRoute();
                })
            }
        },
        deleteProduk: function(id_produk) {
            if(!confirm('Apakah kamu yakin mau menghapus produk ini?')){
                return false
            }
            this.$http.get('Produk/deleteProduk/'+id_produk).then(result => {
                if(result.data.code == '00') {
                    alert('failed delete produk')
                }else {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Produk '+this.produkDetail.detail.nama_produk+' Berhasil Dihapus',
                        type : 'success'
                    }
                    this.goBack();
                }
            }, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            })
        },
        showingStokOpname: function() {
            console.log('masuk gan')
            this.showStokOpname = true;
        },
        closingStokOpname: function() {
            //get pelanggan list
            this.showStokOpname = false;
            this.init();
        },
        viewMoreHistory: function() {
            this.rowHistory = this.rowHistory+10;
            this.$root.is_loading = true
            this.$http.get('Produk/getHistoryProduk/'+this.id_produk+'/'+this.rowHistory).then( result => {
                if(result.data.code == '01') {
                    this.produkDetail.history = result.data.detail
                }
                this.$root.is_loading = false
            }, error => {
                console.log(error)
                this.$root.is_loading = false
            })
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
    },
    components: {
        StokOpname
    },
    watch: {
        
    },
    computed: {
        kapabilitasProduksiComputed: function() {
            return Math.min.apply(Math,this.kapabilitasProduksi)
        },
        computePerkiraanProduksi: function() {
            var total = 0
            let that = this
            this.dataProduksi.forEach(function(val,i){
                var perProduk = val.perkiraan_biaya * that.qty_produce
                total = total + perProduk
            })
            return total
        },
        
    },
}
</script>


// WEBPACK FOOTER //
// src/components/produk/ProdukDetail.vue